export const config = {
  context: "/account-auth",
  userInfoUrl: "/me",
  gaId: "GTM-TLQZ88R",
  appleClientId: "newsguard.account.service",
  env: "local",
  clientUrl: "https://local.newsguardtech.com"
};
